import React from "react";
import MuiSlider from "@mui/material/Slider";

type Props = {
  min: number;
  max: number;
  value: [number];
  onChange: Function;
  onChangeCommitted: Function;
  valueLabelDisplay: "auto" | "off" | "on";
  valueLabelFormat: Function | string;
  marks: Array<{ label?: string; value: number }>;
  sliderValue?: string;
  valueIndex?: number;
  mainValue?: number;
};

function Slider({
  sliderValue,
  mainValue,
  valueIndex,
  ...rest
}: Props): JSX.Element {
  // @ts-ignore
  return <MuiSlider {...rest} />;
}

export default Slider;
